module.exports = __webpack_public_path__ + "static/media/logo_home.6ce7d5e6.png";